import { Component, Input, OnInit } from '@angular/core';
import { HelperService, HTTPService } from 'app/services';

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-invoice-counter',
  templateUrl: './invoice-counter.component.html',
  styleUrls: ['./invoice-counter.component.scss'],
  providers: [DialogService],
})
export class InvoiceCounterComponent implements OnInit {
  companyId: string = '';
  isProcessing: boolean = false;
  currentInvoiceCounter: number;
  newInvoiceCounter: number;
  error: string = '';

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    const data = this.dynamicDialogConfig.data;

    if (data) {
      this.currentInvoiceCounter = data.currentInvoiceCounter;
      this.companyId = data.companyId;
    }
  }

  isSaveDisabled() {
    if (
      !this.newInvoiceCounter ||
      Number(this.currentInvoiceCounter) > Number(this.newInvoiceCounter)
    ) {
      return true;
    }

    return false;
  }

  handleChange(newInvoiceCounter: number) {
    this.newInvoiceCounter = newInvoiceCounter;
  }

  handleBlur() {
    if (this.currentInvoiceCounter > this.newInvoiceCounter) {
      this.error = `Invoice counter can't be decreased`;
    } else {
      this.error = '';
    }
  }

  handleClose() {
    this.dynamicDialogRef.close({
      isSuccess: false,
    });
  }

  handleSubmit() {
    if (Number(this.newInvoiceCounter) < Number(this.currentInvoiceCounter)) {
      this.helperService.showToaster(
        'error',
        `Invoice counter can't be decreased`
      );
      return;
    }

    this.httpService
      .updateInvoiceCounter({ newInvoiceCounter: this.newInvoiceCounter }, this.companyId)
      .then(
        (res) => {
          this.dynamicDialogRef.close({
            isSuccess: true,
            newInvoiceCounter: this.newInvoiceCounter,
          });
          this.helperService.showToaster('success', 'Successfully updated');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
  }
}
